import { render, staticRenderFns } from "./nav-synchronizer.vue?vue&type=template&id=34128908&"
import script from "./nav-synchronizer.vue?vue&type=script&lang=ts&"
export * from "./nav-synchronizer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports